import { createContext, useContext } from 'react';

import { ALL_TASK_ABILITIES, type TaskAbilities } from '@/entities/collab';

/** What the viewer may do with the open task (default: everything, as before collaboration). */
export const CardAbilitiesContext = createContext<TaskAbilities>(ALL_TASK_ABILITIES);

export function useCardAbilities(): TaskAbilities {
  return useContext(CardAbilitiesContext);
}

type EditingSignal = (source: string, active: boolean) => void;

/** Editors tell the dialog while they are open, so others see "X is editing this task". */
export const CardEditingContext = createContext<EditingSignal>(() => undefined);

export function useEditingSignal(): EditingSignal {
  return useContext(CardEditingContext);
}
